import "./style.css";
import React, { useContext } from 'react';
import { HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { section_b2c } from "../../content_option";
import { LanguageContext } from '../../data/language_context';

// Consistent language-key helper
const getLangKey = (selectedLang) => {
  switch (selectedLang) {
    case "Spanish": return "_esp";
    case "Catalan": return "_cat";
    case "English":
    default: return "_eng";
  }
};

export const B2C = () => {
  const { language: selectedLang } = useContext(LanguageContext);
  const langSuffix = getLangKey(selectedLang);

  // Static section labels
  const t = (baseKey) => section_b2c[`${baseKey}${langSuffix}`] || "";

  return (
    <HelmetProvider>
      <Container className="About-header">
        <Row className="sec_sp">

          {/* Left title column */}
          <Col lg="2">
            <h3 className="color_sec py-4">{t("section_services")}</h3>
          </Col>

          {/* Product list */}
          <Col lg="10" className="product-list-container">

            {section_b2c.map((item, i) => {
              const productImage = item.image;
              const productTitle = item[`title${langSuffix}`];
              const productDescription = item[`description${langSuffix}`];

              return (
                <div key={i} className="product_ py-3">
                  <Row className="align-items-start">

                    {/* Image column */}
                    <Col xs={5} md={4} className="product__icon-col">
                      <img
                        src={productImage}
                        alt={`${productTitle} Icon`}
                        className="product__icon"
                      />
                    </Col>

                    {/* Text column */}
                    <Col xs={7} md={8}>
                      <h5 className="product__title">{productTitle}</h5>
                      <p className="product_desc">{productDescription}</p>
                    </Col>

                  </Row>
                </div>
              );
            })}

          </Col>
        </Row>
      </Container>
    </HelmetProvider>
  );
};
